import { AffiliateTypesEnum } from "@/common/types/affiliate";

export const technical = {
    types: {
        [AffiliateTypesEnum.ADMIN]: "Administrator",
        [AffiliateTypesEnum.MANAGER]: "Manager",
        [AffiliateTypesEnum.TECHNICAL]: "Technical",
        [AffiliateTypesEnum.ASSISTANT]: "Assistant",
    },
    labels: {
        technical: "Technical",
    },
    texts: {
        add_technical: "Add Technical",
        technical_limit: "You have already reached the technical limit!",
    },
};
